import React, { useState } from "react";
import { Dropdown, Button } from "react-bootstrap";
import { FiHome, FiFileText, FiPlus } from "react-icons/fi";
import { FaFilePdf, FaFileExcel } from "react-icons/fa";
import AddCandidateModal from "../modals/recruitment/campushiring/AddCandidateModal";
import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";
import { Breadcrumb, Col } from 'react-bootstrap';

export default function CampusHiringHeader() {
  const [show, setShow] = useState(false);

  return (
    <div style={{  fontFamily: "Inter, sans-serif" }}>
      {/* HEADER */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          alignItems: "center",
          marginBottom: 20,
        }}
      >
    
          <Col md={4} sm={12}>
                  <div className="my-auto mb-2">
                    <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Campus Hiring</h4>
        
                    <Breadcrumb
                      style={{
                        background: "transparent",
                        padding: 0,
                        margin: 0,
                        fontSize: "14px",
                      }}
                    >
                      <Breadcrumb.Item>
                      <Link  to="/" >
               
                        <RiHome6Line
                          className="m text-dark"
                          style={{
                            fontSize: "1.2rem", // increased icon size
                            verticalAlign: "middle",
                                                     }}
                        /></Link>
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item
                        linkAs="span"
                        className="text-dark text-decoration-none fs-6"
                      >
                      Recruitment
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item active>
                        <span className="text-dark fs-6">Campus Hiring</span>
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </Col>

        {/* RIGHT */}
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
          {/* EXPORT */}
          <Dropdown>
            <Dropdown.Toggle  className="border border-2 text-dark  bg-white" >
              <FiFileText size={16} /> Export
            </Dropdown.Toggle>

            <Dropdown.Menu style={menuStyle}>
              <Dropdown.Item style={itemStyle}>
                <FaFilePdf style={{ color: "#222020" }} /> Export as PDF
              </Dropdown.Item>
              <Dropdown.Item style={itemStyle}>
                <FaFileExcel style={{ color: "#232524" }} /> Export as Excel
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          {/* ADD BUTTON */}
          <Button
            onClick={() => setShow(true)}
            style={{
              background: "#f97316",
              border: "none",
              display: "flex",
              alignItems: "center",
              gap: 6,
              padding: "8px 14px",
              borderRadius: 8,
            }}
          >
            <FiPlus /> Add New Candidate
          </Button>
        </div>
      </div>

      {/* MODAL */}
      <AddCandidateModal show={show} onHide={() => setShow(false)} />
    </div>
  );
}

/* STYLES */
const btnWhite = {
  background: "#fff",
  border: "1px solid #e5e7eb",
  borderRadius: 8,
  padding: "8px 12px",
  display: "flex",
  alignItems: "center",
  gap: 6,
};

const menuStyle = {
  borderRadius: 10,
  padding: "8px 0",
  minWidth: 200,
  boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
  border: "1px solid #eee",
};

const itemStyle = {
  display: "flex",
  alignItems: "center",
  gap: 10,
  padding: "8px 15px",
};